import { constants } from "@newsela/angelou";

const { ui } = constants.colors;
const white = ui.white[700];

export const addVeilCss = {
  position: "relative",

  "div:first-of-type": {
    width: "100%",
    display: "block",
    pointerEvents: "none",
  },

  "&:before": {
    content: '""',
    position: "absolute",
    background: white,
    opacity: "0.4",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0",
    zIndex: "2",
  },
};
